import axios from 'axios'

export default function send(obj){
    return axios(
        {
            method: 'post',
            url: 'WebSiteApi/MailSender/SendMail',
            data: obj,
            transformRequest: [function (data) {
              let ret = ''
              for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
              }
              return ret
            }],
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
}


// WEBPACK FOOTER //
// ./src/httpServices/mail.js



// WEBPACK FOOTER //
// ./src/httpServices/mail.js